module.exports = __webpack_public_path__ + "static/img/banner_02.c62b454.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/banner_02.jpg
// module id = 6ce3
// module chunks = 1